import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
    selector: '[appAllowDecimal]',
    standalone: true
})
export class AllowDecimalDirective {
    constructor(private el: ElementRef, private renderer: Renderer2) { }
    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        const pattern = /[0-9\.]/;
        if (!pattern.test(event.key)) {
            event.preventDefault();
        }
    }
}
